import Qs from "qs";
import compact from "lodash/compact";
import omit from "lodash/omit";
import isEmpty from "lodash/isEmpty";
import trimStart from "lodash/trimStart";

const HTTPS_RE = new RegExp(/^(https:\/\/|https:\/|)/gi);
const HTTP_RE = new RegExp(/^http:\/\//gi);
const HASH_START_RE = new RegExp(/^#/);
const HTTPS = "https://";
const HTTP = "http://";

export const createURL = (state) => `?${Qs.stringify(state)}`;

export const defaultHttps = (href) => {
  if (href && !HASH_START_RE.test(href)) {
    const isInsecureTarget = compact(href.match(HTTP_RE));
    const prefix = isInsecureTarget.length ? HTTP : HTTPS;

    const secureMatches = compact(href.match(HTTPS_RE));

    let suffix;

    if (secureMatches.length) {
      const memoCopy = href;

      suffix = secureMatches.reduce((memo, match) => {
        memo = memo.replace(match, "");
        return memo;
      }, memoCopy);
    } else {
      const parts = href.split(":/");
      const sliceIndex = parts.length > 1 ? 1 : 0;
      suffix = parts.slice(sliceIndex).join("");
    }

    return `${prefix}${trimStart(suffix, "/")}`;
  } else {
    return "";
  }
};

export const HREF_TYPE = {
  LINK: "link",
  MAILTO: "mailto",
  TEL: "tel"
};

export const setHrefWithType = ({ href, hrefType }) => {
  return hrefType && hrefType !== HREF_TYPE.LINK
    ? `${hrefType}:${href}`
    : defaultHttps(href);
};

export const omitQueryStringKeys = (url, keys) => {
  const urlParts = url.split("?");
  if (urlParts[1]) {
    const parts = Qs.parse(urlParts[1]);
    const remainder = omit(parts, keys);

    return isEmpty(remainder)
      ? urlParts[0]
      : `${urlParts[0]}?${Qs.stringify(remainder)}`;
  } else {
    return url;
  }
};
